//claimsData.ts
import {
  Claim,
  ClaimType,
  ClaimStatus,
  ProcedureStatus,
  ClaimAttachment,
} from '@dataTypes/claimManagement.types'

const claimsData: Claim[] = [
  {
    id: 'C12345',
    date: '2024-12-01',
    patientId: 'P001',
    patientName: 'John Doe',
    claimForm: 'ADA 2025',
    claimType: ClaimType.Standard,
    patientAddress: {
      street: '123 Main St',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90001',
      country: 'USA',
    },
    clinicName: 'Health Clinic',
    providerName: 'Dr. Smith',
    insuranceProviderId: 'INS001',
    insuranceProvider: 'ABC Insurance',
    claimAmount: 500,
    amountPaid: 400,
    status: ClaimStatus.UnderReview,
    notes: 'Awaiting documents',
    photo: '/boy.png',
    groupName: 'Tech Corp',
    groupId: 'TC001',
    patientSubscriber: {
      subscriberId: 'SUB001',
      name: 'Michael Doe',
      relationship: 'Father',
      contact: '555-123-4567',
    },
    claimDetails: [],
    procedures: [
      {
        procedureName: 'Teeth Cleaning',
        procedureCode: 'D1110',
        procedureDate: '2024-11-29',
        provider: 'Dr. Smith',
        providerFirstName: 'John',
        providerLastName: 'Smith',
        coverage: '80%',
        amount: 150,
        status: ProcedureStatus.Claimed,
      },
    ],
    attachments: [
      {
        itemNo: 1,
        item: 'X-Ray Image',
        formatType: 'JPEG',
        orientation: 'Portrait',
        dateTaken: '2024-11-30',
        fileName: 'xray1.jpg',
        notes: [
          {
            author: 'Current User',
            content: 'Uploaded X-Ray for verification.',
            date: '2024-12-01 10:30:45',
          },
        ],
      },
      {
        itemNo: 2,
        item: 'Insurance Form',
        formatType: 'PDF',
        orientation: 'Landscape',
        dateTaken: '2024-12-01',
        fileName: 'insurance_form.pdf',
        notes: [
          {
            author: 'Current User',
            content: 'Submitted insurance form for processing.',
            date: '2024-12-01 11:15:20',
          },
        ],
      },
    ] as ClaimAttachment[],
  },
  {
    id: 'C12346',
    date: '2024-12-05',
    patientId: 'P002',
    patientName: 'Jane Doe',
    claimForm: 'ADA 2025',
    claimType: ClaimType.Standard,
    patientAddress: {
      street: '456 Park Ave',
      city: 'New York',
      state: 'NY',
      zipCode: '10022',
      country: 'USA',
    },
    clinicName: 'Wellness Center',
    providerName: 'Dr. Brown',
    insuranceProviderId: 'INS002',
    insuranceProvider: 'XYZ Insurance',
    claimAmount: 300,
    amountPaid: 300,
    status: ClaimStatus.Approved,
    notes: 'Claim approved successfully.',
    photo: '/girl.png',
    groupName: 'Wellness Solutions',
    groupId: 'WSL002',
    patientSubscriber: {
      subscriberId: 'SUB002',
      name: 'Emily Doe',
      relationship: 'Mother',
      contact: '555-987-6543',
    },
    claimDetails: [],
    procedures: [
      {
        procedureName: 'Extraction',
        procedureCode: 'D1208',
        procedureDate: '2024-12-02',
        provider: 'Dr. Brown',
        providerFirstName: 'David',
        providerLastName: 'Brown',
        coverage: '100%',
        amount: 50,
        status: ProcedureStatus.Claimed,
      },
    ],
    attachments: [
      {
        itemNo: 1,
        item: 'Prescription Document',
        formatType: 'PDF',
        orientation: 'Portrait',
        dateTaken: '2024-12-03',
        fileName: 'prescription.pdf',
        notes: [
          {
            author: 'Current User',
            content: 'Prescription uploaded for medication approval.',
            date: '2024-12-03 09:45:00',
          },
        ],
      },
    ] as ClaimAttachment[],
  },
  {
    id: 'C12347',
    date: '2024-12-10',
    patientId: 'P003',
    patientName: 'Mark Johnson',
    claimForm: 'ADA 2025',
    claimType: ClaimType.Standard,
    patientAddress: {
      street: '789 Elm St',
      city: 'Chicago',
      state: 'IL',
      zipCode: '60601',
      country: 'USA',
    },
    clinicName: 'Smile Dental',
    providerName: 'Dr. Williams',
    insuranceProviderId: 'INS003',
    insuranceProvider: 'Delta Dental',
    claimAmount: 800,
    amountPaid: 700,
    status: ClaimStatus.UnderReview,
    notes: 'Awaiting approval from insurance.',
    photo: '/boy.png',
    groupName: 'Dental Care Group',
    groupId: 'DCG003',
    patientSubscriber: {
      subscriberId: 'SUB003',
      name: 'Sarah Johnson',
      relationship: 'Wife',
      contact: '555-678-9012',
    },
    claimDetails: [],
    procedures: [
      {
        procedureName: 'Root Canal',
        procedureCode: 'D3310',
        procedureDate: '2024-12-07',
        provider: 'Dr. Williams',
        providerFirstName: 'Robert',
        providerLastName: 'Williams',
        coverage: '75%',
        amount: 600,
        status: ProcedureStatus.Claimed,
      },
    ],
    attachments: [
      {
        itemNo: 1,
        item: 'Medical Document',
        formatType: 'Docx',
        orientation: 'Portrait',
        dateTaken: '2024-12-03',
        fileName: 'medical.docx',
        notes: [
          {
            author: 'Current User',
            content: 'Medical report added for insurance review.',
            date: '2024-12-04 14:20:30',
          },
        ],
      },
    ] as ClaimAttachment[],
  },
]

export default claimsData
